import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { deactivateReadingGoal } from 'api/mutations/reading-goals'
import { useTranslation } from 'i18n'
import useToast from 'utils/hooks/use-toast'
import type { RemoveReadingGoalModalProps } from './RemoveReadingGoalModal.types'

export const useRemoveReadingGoalModal = ({
  onClose,
  entityGoalRemoving
}: Pick<RemoveReadingGoalModalProps, 'onClose' | 'entityGoalRemoving'>) => {
  const [submitting, setSubmitting] = useState(false)
  const [removed, setRemoved] = useState(false)
  const [deactivateReadingGoalMutation] = useMutation(deactivateReadingGoal, {
    refetchQueries: ['GetReadingGoalsByEntities']
  })
  const { toastMessage } = useToast()
  const { t } = useTranslation()

  const handleClose = () => {
    setRemoved(false)
    onClose()
  }

  const handleRemove = () => {
    if (!entityGoalRemoving || submitting) {
      return
    }

    setSubmitting(true)
    deactivateReadingGoalMutation({
      variables: { entityId: entityGoalRemoving.entityId }
    })
      .then(() => {
        setSubmitting(false)
        setRemoved(true)
      })
      .catch(() => {
        setSubmitting(false)
        toastMessage({
          message: t(
            'Houve um problema ao remover a meta de leitura. Tente novamente.'
          ),
          type: 'error'
        })
      })
  }

  return {
    submitting,
    removed,
    handleClose,
    handleRemove
  }
}
